<script lang="ts">
	export let color = "";
	export let circleBackground = "#6d6f76";

	console.log("color", color)
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 121 115.098"
	overflow="visible"
>
	<defs>
		<mask id="ping">
			<path
				data-name="패스 310"
				d="M-1266.722 324.534a2.912 2.912 0 0 1-2.086-.879l-24.951-25.616a2.912 2.912 0 0 1 .054-4.118 2.913 2.913 0 0 1 4.118.054l22.838 23.446 51.241-54a2.912 2.912 0 0 1 4.118-.108 2.914 2.914 0 0 1 .108 4.118l-53.326 56.194a2.909 2.909 0 0 1-2.094.907z"
				style="fill : #fff"
				transform="translate(1322.52 -248.81)"
			/>
		</mask>
	</defs>
	<circle
		id="main-circle"
		data-name="타원 58"
		cx="57.549"
		cy="57.549"
		r="57"
		style={`fill:${circleBackground}`}
	/>
	<path style="storke; " />

	<circle id="c" data-name="타원 59" cx="118" cy="8.432" r="3.956" />
	<path
		id="b"
		class:black={color === "#000000"}
		mask="url(#ping)"
		style="stroke-width:11px; fill:none"
		d="M 113.05 13.418 L 56.016 72.96 L 27.971 43.715"
	/>
</svg>

<style lang="scss">
	#main-circle {
		-webkit-transform-origin: 50% 50%;
		transform-origin: 50% 50%;
		transform: scale(0.057);
		animation: scale-up 1s cubic-bezier(0.55, -0.01, 0, 1.5) forwards;
	}

	#a {
		/* 0 ~ 119 */
		stroke-dasharray: 3;
		stroke-dashoffset: 110;
		stroke: white;
		fill: white;
	}

	#b {
		stroke-dasharray: 200;
		//275 ~ 400
		stroke-dashoffset: 275;
		stroke: white;
		animation: dash 0.4s linear forwards;
		animation-delay: 0.4s;

		&.black {
			stroke: #000000 !important;
		}
	}

	#c {
		fill: rgb(101, 145, 250);
		opacity: 0;
		animation: opacity 0.1s linear forwards;
		animation-delay: 0.9s;
	}

	@keyframes scale-up {
		to {
			transform-origin: center center;
			transform: scale(0.99);
		}
	}

	@keyframes opacity {
		to {
			opacity: 1;
		}
	}

	@keyframes dash {
		to {
			stroke-dashoffset: 400;
		}
	}
</style>
